<template>
<div>
  <el-dialog
      title="历史操作记录"
      :visible.sync="showHistoryDia"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      show-close>
      <el-table
        :data="historyListData"
        style="width: 100%"
        border
        height="500">
        <el-table-column
          prop="strStateValue"
          width="120"
          label="状态">
        </el-table-column>
        <el-table-column
          prop="strLogContent"
          label="操作">
        </el-table-column>
        <el-table-column
          prop="nLogCreateTime"
          width="160"
          label="处理时间">
          <template slot-scope="scope">
            <div v-if="scope.row.nLogCreateTime !=0 && scope.row.nLogCreateTime !=null">
              {{ scope.row.nLogCreateTime | FormatDate('yyyy-MM-dd hh:mm:ss') }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
</div>
</template>

<script>
import PageNation from "./PageNation";
import ApiService from "../../service/ApiService";
import pub from "../../service/public";
export default {
  name: "OperationRecord",
  components:{
    PageNation:PageNation,
  },
  data(){
    return{
      historyListData: [],
      showHistoryDia:false,
      operationType:[],
    }
  },
  methods:{
    getHistoryOperation(item){
      this.historyListData = [];
      let params = {
        "page": {
          "number": 0,
          "limit": 1
        },
        "keyWord": [],
        "parms": {
          strCheckupCode: item.strCheckupCode,
          enOrderType:300
        }
      };
      ApiService.GetLogs(params).then(res => {
					this.loading = false;
					if (res.code === pub.backCode.SUCCESS) {
						this.historyListData = res.data.pageList;
					} else {
            pub.analysisReturnCode(res, () => this.getHistoryOperation(item));
          }
				}).catch(error => {
					if (error == "Error: Request failed with status code 400") {
						this.$message({
							showClose: true,
							message: error,
							type: 'error',
							duration: 2000
						});
					}
					this.loading = false;
				});
    },
    showOperationListDia(item){
      this.showHistoryDia = true;
      this.getHistoryOperation(item);
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Common/OperationRecord.vue